module.exports = __webpack_public_path__ + "img/genesis-drop-impostor-2.af63e923.svg";